<template>
	<div class="MainBox">
    <!-- 面包屑导航 -->
    <K-Column :column="column"></K-Column>

    <!-- 表格内容 -->
    <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
    <table class="table StripeTable" v-else>
      <thead>
        <tr>
          <th>码标</th>
          <th>手机号</th>
          <th>验证码</th>
          <th>查询状态</th>
          <th>ip</th>
          <th>查询时间</th>
          <!-- <th>操作</th> -->
        </tr>
      </thead>
      <tbody class="TRHoverStyle">
        <tr v-for="(item,index) in datas" v-bind:key="index">
          <td v-text="item.code"></td>
          <td v-text="item.mobile"></td>
          <td v-text="item.vcode"></td>
          <td class="TdStatus">
            <a>
              <i :class="item.state.includes('验证成功')?'pass':'reject'"></i>{{item.state}}
            </a>
          </td>
          <td v-text="item.ip"></td>
          <td v-text="item.created_at"></td>
          <!-- <td style="width:245px">
            <div class="btnArray">
              <a class="btnStyleTwo btnRadius blueBackColor">码标查询</a>
            </div>
          </td> -->
        </tr>
      </tbody>
    </table>

    <!-- 分页器 -->
    <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>
	</div>
</template>

<script>
var self;
import axios from 'axios'
import Column from '@/components/common/Column.vue'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
export default {
  name: 'MobileQRRecords',
  components: {
    'K-Column': Column,
    'K-Paging': Paging,
    'K-Transition': Transition
  },
  data () {
    return {
      column:[
        {name:'手机查询记录',url:'MobileQRRecords'}
      ],
      page:1,
      subHint:'数据加载中...',
      isLoding:true,
      totalPages:0,
      datas:null
    }
  },
  created () {
    self = this;
  },
  mounted () {
    self.GetList();
  },
  methods: {
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      var datas = {
        page: self.page,datas,
        province: self.$route.query.province || ''
      }
      axios.post(self.GetServerUrl(1)+"mobile_check_list",datas)
      .then(function (response){
        self.isLoding = false;

        let datas = response.data.meta.data;
        self.datas = datas;
        self.totalPages = response.data.meta.last_page;  //总页数
        if(!datas.length){
          self.datas = null;
          self.subHint = "无信息！";
        }
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    }
  }
}
</script>

<style scoped>
th{
  padding:20px !important;
}
td{
  padding:20px !important;
}
</style>
